import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { apolloService } from '../../common/services'

import { ASSIGN_USER_TO_MENU_CURATION_TASK_MUTATION } from '../graphql/mutations'
import { ASSIGN_MENU_CURATION_TASK_USER } from '../redux/action-types'

const useAssignUserToMenuCurationTaskMutation = (
  menuCurationTaskId,
  actionType,
) => {
  const dispatch = useDispatch()

  const mutate = useCallback(
    userId =>
      apolloService.mutate({
        mutation: ASSIGN_USER_TO_MENU_CURATION_TASK_MUTATION,
        variables: { id: menuCurationTaskId, userId, actionType },
        dispatch,
        action: ASSIGN_MENU_CURATION_TASK_USER,
      }),
    [actionType, menuCurationTaskId, dispatch],
  )

  return [mutate]
}

export default useAssignUserToMenuCurationTaskMutation
